import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { ERequestType } from "../../Enum/ERequestType"
import { orderMemory } from "../../Objects/Memory/Memory"
import { OrderEntity } from "../../Objects/Order/OrderEntity"
import { GetRequest, PostRequest } from "../../services/ApiClientService"

export const useTableSelfServiceOrders = () => {
  const { t } = useTranslation()
  const { setError } = useError()

  const handleReloadTableSelfServiceOrders = async (restaurantSlug?: string) => {
    if (!restaurantSlug) {
      return false
    }

    try {
      const response = await GetRequest<OrderEntity[]>(
        API_ROUTES.ORDER.GET_TABLE_SELF_SERVICE_OPEN(restaurantSlug),
        ERequestType.TableSelfService,
      )

      if (!response.success) {
        throw new Error(response.message)
      }

      orderMemory.setList(response.data?.map((order) => new OrderEntity(order)) ?? [])
      return true
    } catch (error) {
      setError(
        t("general:label_title_erro"),
        error instanceof Error ? error.message : t("general:label_unknown_error_description"),
      )
      return false
    }
  }

  const handleCancelTableSelfServiceOrder = async (restaurantSlug: string | undefined, order: OrderEntity) => {
    if (!restaurantSlug) {
      return false
    }

    try {
      const response = await PostRequest(
        API_ROUTES.ORDER.CANCEL_TABLE_SELF_SERVICE(restaurantSlug, order.id),
        { concurrencyToken: order.concurrencyToken },
        ERequestType.TableSelfService,
      )

      if (!response.success) {
        throw new Error(response.message)
      }

      await handleReloadTableSelfServiceOrders(restaurantSlug)
      return true
    } catch (error) {
      setError(
        t("general:label_title_erro"),
        error instanceof Error ? error.message : t("general:label_unknown_error_description"),
      )
      return false
    }
  }

  return {
    handleCancelTableSelfServiceOrder,
    handleReloadTableSelfServiceOrders,
  }
}
